<template>
	<AsiDialog :icon="icons.fileImage" :open="open" :title="brand.name" @cancel="cancel">
		<AsiFormErrors :errors="errors" class="mb-6"/>
		<AsiContentContainer>
			<v-file-input
				v-model="selectedFile"
				:label="$t('ui.terms.selectImageFile')"
				accept="image/*"
			/>

			<AsiBtn :disabled="!selectedFile" class="mt-6" color="success" @click="saveImage">
				{{ $t('ui.upload') }}
			</AsiBtn>
		</AsiContentContainer>
	</AsiDialog>
</template>

<script lang="ts">
	import {Vue, Component, Prop, Emit} from 'vue-property-decorator';
	import AsiDialog from "@/components/common/AsiDialog.vue";
	import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
	import AsiBtn from "@/components/common/AsiBtn.vue";
	import {IBrandAdmin} from "@/models/brand/BrandAdminModels";
	import Icon from "@/plugins/icons";
	import {AxiosError} from "axios";
	import Snackbar from "@/helpers/Snackbar";
	import AsiFormErrors from "@/components/common/AsiFormErrors.vue";

	@Component({
		components: {AsiFormErrors, AsiBtn, AsiContentContainer, AsiDialog}
	})
	export default class BrandUpdateImageDialog extends Vue {

		@Prop({type: Object, required: true})
		public brand!: IBrandAdmin;

		@Prop({type: Boolean, default: false})
		public open!: boolean;

		private selectedFile: File | null = null;
		private icons = Icon;
		private errors: string[] = [];

		@Emit('cancel')
		public cancel(): void {
			this.reset();
		}

		@Emit('save')
		public save(): void {
			this.reset();
		}

		private reset(): void {
			this.selectedFile = null;
			this.errors = [];
		}

		private async saveImage(): Promise<void> {
			if (!this.selectedFile || !this.brand.id) {
				return;
			}

			await this.$brandServiceAdmin.uploadBrandImage(
				this.brand.id,
				this.selectedFile
			)
				.then(() => { this.save(); })
				.catch((err: AxiosError) => {
					this.handleUploadError(err);
				});
		}

		private handleUploadError(err: AxiosError): void {
			if (err.response?.status === 413) {
				this.errors = [this.$t('snackbar.uploadErrorFileSize').toString()];
			} else {
				this.errors = [err.response?.data];
			}
			Snackbar.uploadError(err);
		}
	}
</script>

<style scoped lang="scss">

</style>
